import axios from '../../http'

import { handleGetRequestParams } from '../../common/js/util'
class XBCoupon {
  // 可领取的优惠券列表
  getUsableCouponList() {
    const url = `/api/index/coupon/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 领取优惠券
  receiveCoupon(data) {
    const url = `/api/xb/coupon/receive`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 获取xb所拥有的优惠券列表
  getUserCouponList() {
    const url = `/api/xb/coupon/list`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 使用优惠券跳转所使用商品列表
  getCommodityListWithCoupon(options) {
    let url = `/api/xb/coupon/goods/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除优惠券
  deleteCoupon(data) {
    const url = `/api/xb/coupon/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBCoupon
